<template>
  <section class="min-h-screen" style="display: flex;align-items: end;">
    <div class="row" style="flex:1;">
      <div class="col-lg-8 mx-auto">
        <div class="row mx-auto">
          <div class="col-lg-8 col-md-7 mx-auto text-white text-start">
            <div class="position-relative height-control">
              <h1 class="title" style="font-size: 50px;">A Smarter Financial Future <br class="d-md-block d-none"> with Nabaco AI</h1>
              <h5 class="margin-top-div" style="line-height: 30px;">
                We have designed and introduced artificial intelligence as a powerful tool to transform the way you make financial decisions.
                Using advanced algorithms, we analyze vast amounts of financial data to deliver accurate and reliable predictions.
                If you are active in the financial markets, Nabaco AI helps you reduce risk and increase profitability.
              </h5>
              <div style="z-index: 1;">
                <button class="btn-gold my-2"><a href="../sign-up" style="color: black; text-decoration: none;">Get Started with NABACO AI</a></button>
                <button class="btn-border-gold mx-3 my-2">Get a Free Consultation</button>
              </div>
            </div>
            
          </div>
          <div class="col-lg-4 col-md-5 mx-auto" style="padding-bottom: -5px !important;">
            <img src="../../assets/test/home-img.png" class="size-img" alt="">
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="row w-100 py-4 mx-0 px-0 text-white" style="background-color: #3a4375;">
      <div class="col-sm-4 text-center mx-auto">
        <FontAwesomeIcon icon="fa-solid fa-headset" class="text-white fs-3"/>
        24/7 Support
      </div>
      <div class="col-sm-4 text-center mx-auto">
        <FontAwesomeIcon icon="fa-solid fa-user-group" class="text-white fs-3"/>
        Expert and Experienced Team
      </div>
      <div class="col-sm-4 text-center mx-auto">
        <FontAwesomeIcon icon="fa-solid fa-shield-halved" class="text-white fs-3"/>
        Secure Asset Management
      </div>
  </div>
  <section class="d-flex align-items-center w-100" style="min-height: 90vh;">
    <div class="mx-auto mt-5 pt-5">
      <h2 class="title">Human and AI Collaboration: A Smarter, More Efficient Future</h2>
      <h5 style="font-weight: bold;" class="mt-4 d-md-block d-none">In today’s world, the combination of human capabilities and the unmatched power of artificial intelligence is opening new frontiers in innovation and effectiveness <br>This collaboration is not only about using intelligent tools, but also about establishing a mutual coexistence <br> That connects the strengths of humans and machines.</h5>
      <h6 style="font-weight: bold;" class="mt-4 d-md-none d-block">In today’s world, the combination of human capabilities and the unmatched power of artificial intelligence is opening new frontiers in innovation and effectiveness <br>This collaboration is not only about using intelligent tools, but also about establishing a mutual coexistence <br> That connects the strengths of humans and machines.</h6>
      <div class="row col-md-8 mx-auto mt-4">
        <div class="col-sm-6 mx-auto">
          <div class="card-1 bg-1 d-flex align-items-end">
            <div class="card p-3 text-end">
              <h5 style="font-weight: bold;">Human Role</h5>
              <span style="font-weight: bold; font-size: 14px;">Humans continue to bring creativity, strategic decision-making, and empathy. The ability to understand emotions, consider values, and make ethical judgments are qualities that technology cannot fully replicate.</span>
            </div>
          </div>
        </div>
        <div class="col-sm-6 mx-auto">
          <div class="card-1 bg-2 d-flex align-items-end my-md-0 my-3">
            <div class="card p-3 text-end">
              <h5 style="font-weight: bold;">AI’s Role</h5>
              <span style="font-weight: bold; font-size: 14px;">On the other hand, artificial intelligence can analyze data with high speed and accuracy, identify patterns, and provide complex predictions. This technology lifts heavy burdens off humans and frees up time to focus on more critical aspects.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  <section class="d-flex align-items-center w-100" style="height: 100vh;background-color: #000;color: white;">
    <div class="mx-auto row">
      <div class="col-md-8 mx-auto">
        <h1 style="font-weight: bold;">Nabaco Trading Assistant</h1>
        <h5 class="mt-5">The Nabaco AI Trading Assistant is designed to help you make smarter and more successful decisions in the fast-paced, complex world of financial trading. By leveraging real-time data analysis and accurate predictions, this assistant equips you to maximize returns and minimize trading risks.</h5>
      </div>
      <div class="mt-4">
        <h6>Trade smarter than ever with Nabaco AI Trading Assistant <a href="../sign-up">Sign up</a> now and harness the power of AI!</h6>
        <button class="btn-gold mt-5">
          <a href="https://survey.porsline.ir/s/sP04J912" style="color: black; text-decoration: none;">Test Link</a>
        </button>
      </div>
    </div>
  </section>
  <section class="d-flex align-items-center w-100" style="min-height: 90vh;">
    <div class="mx-auto row col-md-8">
      <div class="col-12 pe-5 my-xl-auto my-5">
     <h2 style="font-weight: bold;">Tokenization of Assets with NABACO AI</h2>
     <h4 style="font-weight: bold;">Converting assets into tokens on the blockchain — transparent, secure, and traceable</h4>
     <div class="row mt-3">
       <h5 class="mt-1">
         In today’s world, blockchain technology is not limited to cryptocurrencies. With tokenization, we can convert any type of asset (such as real estate, stocks, contracts, or even artworks) into a digital token on the blockchain. NABACO, by offering specialized tokenization services, helps you digitize your assets in a modern, transparent, and secure way.
         <br><br>
         <div class="row">
           <div class="col-lg-4 col-md-6 d-flex my-2">
             <div class="card-2 p-4">
               <h5 style="color: #2a377f; font-weight: bold;">1. Smart Targeting</h5>
               <h6>By converting assets into digital tokens, you pave the way for attracting investment, liquidity, and diversification. At NABACO, we design tokenization models like ownership-based, profit-sharing, and security tokens to turn your project’s strategic goals into reality.</h6>
             </div>
           </div>
           <div class="col-lg-4 col-md-6 d-flex my-2">
             <div class="card-2 p-4">
               <h5 style="color: #2a377f; font-weight: bold;">2. Choosing the Right Infrastructure</h5>
               <h6>Selecting blockchains such as Ethereum, Polygon, or Solana according to your project’s needs and implementing professional token standards like ERC-20, ERC-721, and ERC-1155. The result? A scalable, secure, and future-proof system.</h6>
             </div>
           </div>
           <div class="col-lg-4 col-md-6 d-flex my-2">
             <div class="card-2 p-4">
               <h5 style="color: #2a377f; font-weight: bold;">3. Smart Contracts — Trust Without Intermediaries</h5>
               <h6>By deploying automated contracts, asset transfers, payments, and legal compliance are performed without intermediaries. Along with transparent governance mechanisms to protect investors and ensure reliable decision-making.</h6>
             </div>
           </div>
           <div class="col-lg-4 col-md-6 d-flex my-2">
             <div class="card-2 p-4">
               <h5 style="color: #2a377f; font-weight: bold;">4. Global Legal Compliance</h5>
               <h6>Ensuring secure ownership registration and adherence to international regulations with the help of specialized blockchain legal advisors. Building trust, reducing risk, and preparing for sustainable growth start here.</h6>
             </div>
           </div>
           <div class="col-lg-4 col-md-6 d-flex my-2">
             <div class="card-2 p-4">
               <h5 style="color: #2a377f; font-weight: bold;">5. Platform Development and Revenue Models</h5>
               <h6>From digital asset marketplaces to rental systems, staking, and continuous income streams — a transparent and profitable platform for users, investors, and your business.</h6>
             </div>
           </div>
           <div class="col-lg-4 col-md-6 d-flex my-2">
             <div class="card-2 p-4">
               <h5 style="color: #2a377f; font-weight: bold;">6. Attracting Investors with a Powerful Narrative</h5>
               <h6>Communicate your project’s message clearly and convincingly to investors with professional content such as whitepapers and engaging presentations. Trust, participation, and investment begin here.</h6>
             </div>
           </div>
         </div>
       </h5>
     </div>
    </div>

      
    </div>  
  </section>
  <section class="d-flex align-items-center w-100" style="min-height: 100vh;background-color: #000;color: white;">
    <div class="row container mx-auto">
      <div class="col-md-4 my-auto">
        <img src="../../assets/logo.png" class="w-75" style="border-radius: 10px;" alt="">
      </div>
      <div class="col-md-8 text-start pt-md-0 pt-5" style="font-weight: bold;">
        <h2 class="mt-5" style="font-weight: bold;">Nabaco Academy: A Bridge to Knowledge and Success</h2>
        <div class="row mt-5">
          <h5 class="mt-3">
              Nabaco Academy is designed to provide you with the tools and knowledge needed for a deeper understanding of the financial world and advanced technologies. This section of the site serves as a comprehensive educational hub offering high-quality resources, courses, and articles in three key areas: financial literacy, blockchain, and artificial intelligence.
          </h5>
          <h5 class="mt-4">Nabaco Academy Goals</h5>
          <h5 class="mt-3">
              <strong>Enhancing General Knowledge: </strong>We believe that knowledge is power. The goal of Nabaco Academy is to teach complex concepts in a simple and understandable way.
              <br>
              <br>
              <strong>Empowering Traders and Investors: </strong>By providing practical and applicable information, we help you make more informed decisions.
              <br>
              <br>
              <strong>Connecting Knowledge to Action: </strong>Learning concepts alone is not enough; we help you apply what you’ve learned in real life and in your financial trades.
          </h5>
        </div>
      </div>
      <div class="col-1 d-md-block d-none"></div>
    </div>
  </section>
</template>
<script lang="ts">
import { library } from '@fortawesome/fontawesome-svg-core';
import { faHeadset, faShieldHalved, faUserGroup } from '@fortawesome/free-solid-svg-icons';
import { defineComponent } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// import Slider from './slider.vue';

export default defineComponent({
components: {FontAwesomeIcon},
setup(){
  library.add(faShieldHalved,faUserGroup,faHeadset)

  window.onscroll = function () {
    let myNav = document.getElementById('myNav')
    if (myNav) { // Ensure the element exists before applying class
      if (document.body.scrollTop >= 50 || document.documentElement.scrollTop >= 50) {
        myNav.classList.add("nav-colored");
      } else {
        myNav.classList.remove("nav-colored");
      }
    }
};
  
  return{
  }
}

})
</script>

<style lang="scss" scoped>
*{
  direction: ltr;
}

.min-h-screen {
  min-height: 92vh;
  background: linear-gradient(90deg, var(--blue) 0%, #000 100%);
  overflow-x: hidden;
  @media(max-width:1300px) {
    min-height: 65vh !important;
  }
}

.title {
  font-weight: bold;
  @media(max-width:1300px) {
    font-size: 40px !important;
  }
  @media(max-width:765px) {
    font-size: 30px !important;
  }
}
.card-1 {
border: none;
border-radius: 10px;
height: 350px !important;
height: 100%;
padding-bottom: 15px;
padding-left: 15px;
padding-right: 15px;
}

.height-control {
  top: -40px;
  @media(max-width:1300px) {
    top: -10px;
  }
  @media(max-width:991px) {
    top: 60px;
  }
  @media(max-width:765px) {
    top: 10px;
  }
  @media(max-width:540px) {
    top: 60px;
  }
}

.bg-1{
background-image: url('../../assets/test/AcademyBg.png');
background-size: cover;
}
.bg-2{
background-image: url('../../assets/test/FirstSection.png');
background-size: cover;
}
.bg-3{
background-image: url('../../assets/test/BoxBg.png');
background-size: cover;
}

.card-light {
background-color: rgb(245 245 245);
border: solid 2px rgb(224 224 224);
border-radius: 20px;
padding: 15px;
width: 100%;
}

.blog{
border: solid 1px #e9e9e9;
border-radius: 10px;
}

.size-img {
  width: 100%;
  @media(max-width:767px) {
    margin-top: 20px;
    width: 25%;
  }
}
.card-2 {
  background-color: #e7ebff;
  border: none;
  border-radius: 10px;
  // box-shadow: 0px 0px 10px 0px #000;
}
</style>